// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + ({"40":"analysis-report","401":"analysis-detail","766":"analysis-preparing"}[chunkId] || chunkId) + "." + {"40":"902fd8a2","401":"22c442e5","766":"14c8b252","948":"22c442e5"}[chunkId] + ".chunk.css";
};